// purchases-misc-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1p.docs.movedToTrash': 'Dokument flyttet til papirkurv.',
  'r1p.docs.moveFailed': 'Kunne ikke flytte dokument.',
  'r1p.docs.restored': 'Dokument gjenopprettet.',
  'r1p.docs.restoreFailed': 'Kunne ikke gjenopprette dokument.',
  'r1p.docs.confirmDeleteOne': 'Slette dokumentet permanent?',
  'r1p.docs.confirmDeleteMany': 'Slette valgte dokumenter permanent?',
  'r1p.docs.deletedPermanently': 'Dokument slettet permanent.',
  'r1p.docs.deleteFailed': 'Kunne ikke slette dokument.',
  'r1p.selectedCount': '{count} valgt',
  'r1p.sale.backendNotReady': 'Backend-lagring er ikke klar.',
  'r1p.sale.lineRequired': 'Legg til minst én salgslinje.',
  'r1p.manual.noAccountMatch': 'Ingen konto matcher «{query}».',
  'r1p.picker.searchPlaceholder': 'Søk navn, nummer eller f.eks. 4300',
  'r1p.picker.favorite': 'Favoritt',
});
